import { createStore } from 'vuex'

import modules from './modules';
import getters from './getters';

export default createStore({
  state: {
  },
  mutations: {
  },
  getters,
  actions: {
  },
  modules
})
